export default function (firstName?: string, lastName?: string) {
  return `${firstName || ''} ${lastName || ''}`.trim();
}
